import { WithTooltip } from 'metronome-ui/components/WithTooltip'

import IconContainer from './icons/IconContainer'

export const OperationDetailsList = ({ children, className = '' }) =>
  children.length ? (
    children.some(child => child) && (
      <ul className={`rounded-xl px-4 text-sm ${className}`}>{children}</ul>
    )
  ) : (
    <ul className={`rounded-xl px-4 text-sm ${className}`}>{children}</ul>
  )

export const OperationDetailsItem = ({
  children,
  className = '',
  title = '',
  tooltip = ''
}) =>
  children && (
    <li
      className={`flex justify-between py-2 text-sm leading-6 text-white ${
        className ? className : ''
      }`}
    >
      <span className="flex w-auto">
        {title}
        {tooltip && (
          <WithTooltip
            className="ml-2.5 mt-1 text-left"
            overlay={
              <div className="w-80 border-0">
                <p className="mb-2 text-sm text-white">{title}</p>
                <p className="text-xs text-gray-600">{tooltip}</p>
              </div>
            }
          >
            <IconContainer name="exclamationmark" />
          </WithTooltip>
        )}
      </span>

      <span className="flex items-center">{children}</span>
    </li>
  )

export const OperationDetailsPreviewItem = ({
  className = '',
  currentValue = '0',
  currentAsset = '',
  nextValue = '0',
  nextAsset = '',
  title = ''
}) => (
  <OperationDetailsItem className={className} title={title}>
    {currentAsset && (
      <IconContainer
        className="mr-2"
        height="16"
        name={currentAsset}
        width="16"
      />
    )}
    {currentValue}
    <IconContainer
      className="mx-1 h-4 rotate-180"
      name="backarrow"
      stroke="white"
    />
    {nextAsset && (
      <IconContainer className="mr-2" height="16" name={nextAsset} width="16" />
    )}
    {nextValue}
  </OperationDetailsItem>
)
